import { TextInputField } from 'components/Form/TextInputField'
import Styles from '../../../BlogMetadata.module.scss'
import { TextFieldSize } from 'components/Form/useTextFieldCounter'

interface TitleFieldProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  size?: TextFieldSize
}

export const TitleField: React.FC<TitleFieldProps> = ({ value, onChange, size = 'lg' }) => (
  <TextInputField
    wrapperClassName={Styles.inputField}
    label="Title"
    value={value}
    onChange={onChange}
    size={size}
    labelClassName={Styles.textFieldLabel}
  />
)
